import { useId } from 'react';

export const PlaidIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  const id = useId();
  const clip = `${id}-clip`;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" {...props}>
      <g clipPath={`url(#${clip})`}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.45903 2.5L3.86263 3.70384L2.59591 8.32615L4.18018 9.95276L2.57031 11.5525L3.76246 16.195L8.33896 17.4738L9.94914 15.8737L11.5334 17.5L16.1298 16.2962L17.3962 11.6735L15.8123 10.0476L17.4221 8.4478L16.23 3.80495L11.6528 2.52623L10.0433 4.12598L8.45903 2.5ZM5.63837 4.59298L8.05964 3.95851L9.11846 5.04545L7.57432 6.57979L5.63837 4.59298ZM10.9536 5.05998L12.0295 3.99106L14.4403 4.6647L12.4728 6.61961L10.9536 5.05998ZM4.04652 7.94668L4.71353 5.51213L6.64884 7.49895L5.10502 9.03329L4.04652 7.94668ZM13.3825 7.55393L15.35 5.59839L15.9775 8.04399L14.902 9.11323L13.3825 7.55393ZM8.48431 7.5138L10.0284 5.97945L11.5473 7.53907L10.0035 9.07342L8.48431 7.5138ZM6.01532 9.9673L7.55915 8.43295L9.07896 9.99257L7.5345 11.5269L6.01532 9.9673ZM10.9138 10.0074L12.4576 8.47308L13.9768 10.0327L12.4327 11.567L10.9138 10.0074ZM4.01429 11.956L5.09048 10.8865L6.60935 12.4464L4.64244 14.401L4.01429 11.956ZM8.44449 12.4609L9.98864 10.9266L11.5078 12.4862L9.96399 14.0205L8.44449 12.4609ZM13.3426 12.5014L14.8868 10.967L15.9456 12.0536L15.2789 14.4882L13.3426 12.5014ZM5.55211 15.3356L7.51934 13.3801L9.03915 14.9397L7.96296 16.0093L5.55211 15.3356ZM10.874 14.9546L12.4178 13.4202L14.3534 15.4073L11.9325 16.0415L10.874 14.9546Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id={clip}>
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
